export default __webpack_public_path__ + "static/media/logo.deace34a.png";